import { render, staticRenderFns } from "./reward-introduce.vue?vue&type=template&id=b0774690&scoped=true&"
import script from "./reward-introduce.vue?vue&type=script&lang=ts&"
export * from "./reward-introduce.vue?vue&type=script&lang=ts&"
import style0 from "./reward-introduce.vue?vue&type=style&index=0&id=b0774690&lang=less&scoped=true&"
import style1 from "./reward-introduce.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0774690",
  null
  
)

export default component.exports